import { useTranslation } from 'react-i18next';
import { formatCents } from '@/lib/format';
import {
  describeCampaignCpmRates,
  type CampaignCpmRatesInput,
} from '@/lib/campaigns/describeCampaignCpmRates';
import { CampaignCpmRateList } from './CampaignCpmRateList';

type Props = {
  campaign: CampaignCpmRatesInput & { currency: string };
};

/** The /campaigns/:id hero tile with the campaign's CPM, one rate or each network's. */
export function CampaignRateTile({ campaign }: Props) {
  const { t } = useTranslation();
  const rates = describeCampaignCpmRates(campaign);
  return (
    <div
      data-testid="campaign-rate-tile"
      className="bg-background/60 border border-border rounded-xl p-3 sm:p-4"
    >
      <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground mb-1">
        {t('campaign.rateLabel')}
      </p>
      {rates.kind === 'single' ? (
        <>
          <p className="text-xl font-bold">
            {formatCents(rates.rateCents, campaign.currency)}
            <span className="text-sm font-normal text-muted-foreground ml-1">
              {' / '}{t('campaign.per1kViews')}
            </span>
          </p>
          <p className="text-[11px] text-muted-foreground mt-1">
            {t('campaign.rateLabelHint', { rate: formatCents(rates.rateCents, campaign.currency) })}
          </p>
        </>
      ) : (
        <>
          <CampaignCpmRateList
            rates={rates.rates}
            currency={campaign.currency}
            layout="stacked"
            className="text-base"
          />
          <p className="text-[11px] text-muted-foreground mt-1">
            {t('campaign.rateLabelHintPerPlatform')}
          </p>
        </>
      )}
    </div>
  );
}
